import { BuyersPremium, EmptyBuyersPremium } from './BuyersPremium';
import { CoverLot, EmptyCoverLot } from './CoverLot';
import { PaymentOption } from './PaymentOption';
import { PaymentProviders } from '@/enums';
import type { AuctionStatus } from '@/types/LiveAuctionState';

export type CatalogAddress = {
    address1: string;
    address2: string;
    city: string;
    country: string;
    fullCountryName: string;
    lat: number;
    lng: number;
    postalCode: string;
    state: string;
};

export type Catalog = {
    absenteeBidders: number;
    achPayments: boolean;
    address: CatalogAddress;
    buyersPremium: BuyersPremium;
    catalogId: number;
    catalogStatus: AuctionStatus;
    coverLots?: CoverLot[];
    currency: string;
    currencySymbol: string;
    description: string;
    hasExplicitMaterial: boolean;
    hasVideo: boolean;
    highRiskPayments: boolean;
    imagePath: string;
    isAutopay: boolean;
    isCatalogOnly: boolean;
    isSEOExcluded: boolean;
    isTimed: boolean;
    liveAuctioneersPayments: boolean;
    lotsListed: number;
    paymentOptions?: PaymentOption;
    paymentProvider?: PaymentProviders;
    payrixPayments: boolean;
    preview: string;
    publishDateTs?: number;
    saleEndTs: number;
    saleStartTs: number;
    sellerId: number;
    title: string;
};

export const EmptyCatalog: Catalog = {
    absenteeBidders: 0,
    achPayments: false,
    address: {
        address1: '',
        address2: '',
        city: '',
        country: '',
        fullCountryName: '',
        lat: 0,
        lng: 0,
        postalCode: '',
        state: '',
    },
    buyersPremium: EmptyBuyersPremium,
    catalogId: 0,
    catalogStatus: 'done',
    coverLots: [EmptyCoverLot],
    currency: 'USD',
    currencySymbol: '',
    description: '',
    hasExplicitMaterial: false,
    hasVideo: false,
    highRiskPayments: false,
    imagePath: '',
    isAutopay: false,
    isCatalogOnly: false,
    isSEOExcluded: false,
    isTimed: false,
    liveAuctioneersPayments: false,
    lotsListed: 0,
    payrixPayments: false,
    preview: '',
    publishDateTs: 0,
    saleEndTs: 0,
    saleStartTs: 0,
    sellerId: 0,
    title: '',
};
